const AGE_GROUP = Object.freeze({
  ADULT: {
    id: "ODRASEL",
    translationKey: "ageGroup.ADULT",
    color: "black",
  },
  CUB: {
    id: "MLADIC",
    translationKey: "ageGroup.CUB",
    color: "light",
  },
});
export const RAZVOJNI_STADIJ_SIFRA_MAP = {
  MLADIC: AGE_GROUP.CUB,
  ODRASEL: AGE_GROUP.ADULT,
};
export const AGE_GROUP_LIST = Object.freeze([AGE_GROUP.CUB, AGE_GROUP.ADULT]);

export default AGE_GROUP;
